import { Facet } from '../models/Facet';

/**
 * Facet to apply to an error to provide an HTTP status code.
 */
export const httpStatusErrorFacet = new Facet<number>('httpStatus');

/**
 * Facet to attach to an error indicating that that an item is in conflict.
 */
export const conflictErrorFacet = new Facet<{
  supportsRename?: boolean;
}>('conflict');

/**
 * Facet to attach to an error indicating that the user is offline.
 */
export const offlineErrorFacet = new Facet<{}>('offlineError');

/**
 * Facet to attach to an error indicating that the user does not have access to a resource.
 */
export const accessDeniedErrorFacet = new Facet<{}>('accessDeniedError');

/**
 * Facet to attach to an error indicating that the operation may be retried.
 */
export const retryErrorFacet = new Facet<{}>('retryError');

/**
 * Facet to attach to an error indicating that the file was not found
 * @deprecated `fileNotFoundErrorFacet` should no longer be used.
 */
export const fileNotFoundErrorFacet = new Facet<{}>('fileNotFound');

/**
 * Facet to attach to an error indicating that an item has invalid name.
 */
export const invalidNameErrorFacet = new Facet<{}>('invalidNameError');
/**
 * Facet to attach to an error indicating that an item is oversize.
 */
export const fileSizeErrorFacet = new Facet<{
  maxFileSize?: number;
}>('fileSizeError');
/**
 * Facet to attach to an error indicating that an item is an empty folder.
 */
export const emptyFolderUnsupportedFacet = new Facet<{}>('emptyFolderUnsupported');
/**
 * Facet to attach to an error indicating that owner of the upload destination reached upload quota.
 */
export const overQuotaErrorFacet = new Facet<{
  quotaLimit?: number;
}>('overQuotaError');
/**
 * Facet to attach to an error indicating that an item is being opened.
 */
export const lockMismatchErrorFacet = new Facet<{}>('lockMismatchError');
/**
 * Facet to attach to an error indicating that user's cookies expired.
 */
export const authFailureErrorFacet = new Facet<{}>('authFailureError');
/**
 * Facet to attach to an error indicating that user's broswer doesn't support folder upload.
 */
export const folderUploadUnsupportedFacet = new Facet<{}>('folderUploadUnsupported');
/**
 * Facet to attach to an error indicating destination folder was deleted.
 */
export const targetFolderErrorFacet = new Facet<{}>('targetFolderError');
/**
 * Facet to attach to an error indicating an item has virus.
 */
export const malwareErrorFacet = new Facet<{}>('malwareError');
/**
 * Facet to attach to an error indicating upload item reaches bandwidth limits.
 */
export const throttleErrorFacet = new Facet<{}>('throttleError');
/**
 * Facet to attach to an error indicating version mismatch.
 */
export const versionMismatchFacet = new Facet<{}>('versionMismatch');
/**
 * Facet to attach to an error indicating the item that was looked up does not seem to exist.
 */
export const itemNotFoundErrorFacet = fileNotFoundErrorFacet;
